var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "12px",
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DDCFE945-33B1-479E-A3EC-4A922CED6F1C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-3-Copy-7",
    transform: "translate(-824.000000, -796.000000)",
    fill: "#E62B33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right-arrow",
    transform: "translate(824.000000, 796.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7250195,5.31498354 L14.8255532,0.281803294 C14.458569,-0.0951807889 13.8649911,-0.0937775623 13.4996944,0.285093618 C13.1344446,0.663916412 13.1358509,1.27664256 13.5028351,1.65367503 L16.7917709,5.03225758 L0.937499535,5.03225758 C0.419718542,5.03225758 0,5.46551588 0,6 C0,6.53448423 0.419718542,6.96774254 0.937499535,6.96774254 L16.7917241,6.96774254 L13.5028819,10.3463251 C13.1358977,10.7233575 13.1344915,11.3360837 13.4997413,11.7149065 C13.865038,12.0938261 14.4586627,12.0951325 14.8256,11.7181968 L19.7242226,6.68593593 C20.092238,6.30672603 20.0910662,5.69201601 19.7250195,5.31498354 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.db5f2febf94ed6cbf27dcba8827095bf.svg";
export { ForwardRef as ReactComponent };